import { init as stickyCTAInit } from './_stickyCta';
import { init as stickyCTANewInit } from './_stickyCtaNew';
import { init as stickyCTANew2Init } from './_stickyCtaNew2';
import { init as ctaTimerInit } from './_ctaTimer';
import { init as zipInit } from './_zipForm';
import { init as searchInit } from './_searchForm';
import { init as channelLineupInit } from './_channelLineup';
import { init as swipeHintInit } from './_swipeHint';
import { init as slickSliderContent } from './_slickSliderContent';
import { init as availabilityMapInit } from './_availabilityMap';
import { init as stateSelectInit } from './_buildStateSelect';
import { init as usMapInit } from './_loadUsMap';
import { init as customTabsInit } from './_tabs';
import { init as disclosureInit } from './_disclosure';
import { init as buttonTopInit } from './_buttonTop';
import { init as buttonChatInit } from './_buttonChat';
import { init as gtmTrackingInit } from './_gtmTracking';
import { init as mapiPriorityAjaxInit } from './_mapiPriorityAjax';
import { init as lazyBeforeUnveilInit } from './_lazyBeforeUnveil';
import { init as zipFunction } from './_blogZipForm';
import { init as scrollingTablesInit } from './_scrollingTables';
import { init as heroCardsEqualHeightInit } from './_heroCardsEqualHeight';
import { init as equalHeight } from './_equalHeight';
import { init as deleteTransients } from './_deleteTransients';
import { init as changeLocationPopup } from './_changeLocationPopup';
import { init as exitPopup } from './_exitPopup';
import { init as headerInit } from './_header';
import { init as emailZipFormInit } from './_emailZipForm';
import { init as internetNearMe } from './_internetNearMe';
import { init as compareProviders } from './_compareProviders';
import { init as fillBar } from './_fillBar';
import { init as currentLocationInit } from './_currentLocation';

// Default initialization routine
const init = () => {
    // Determine module to load based off of script tag data attribute
    // const pageModule = document.querySelector('[data-script-module]');

    // If we have a page module data attribute on the site script tag, initialize it
    // if (pageModule !== null && pageModule.dataset.scriptModule.length > 0) {
    //   require(`../pages/_${pageModule.dataset.scriptModule}.js`).init(); // eslint-disable-line global-require
    // }

    stickyCTAInit();
    stickyCTANewInit();
    stickyCTANew2Init();
    ctaTimerInit();
    zipInit();
    searchInit();
    channelLineupInit();
    swipeHintInit();
    slickSliderContent();
    availabilityMapInit();
    stateSelectInit();
    usMapInit();
    customTabsInit();
    disclosureInit();
    buttonTopInit();
    buttonChatInit();
    gtmTrackingInit();
    mapiPriorityAjaxInit();
    lazyBeforeUnveilInit();
    zipFunction();
    scrollingTablesInit();
    heroCardsEqualHeightInit();
    equalHeight();
    deleteTransients();
    changeLocationPopup();
    exitPopup();
    headerInit();
    emailZipFormInit();
    internetNearMe();
    compareProviders();
    fillBar();
    currentLocationInit();
};

// Export public methods
export { init };
